export default "__VITE_ASSET__G_iLlo4t__"